import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Section } from '@fiverr-private/fit';
import Header from '../Header';
import SideMenu from '../SideMenu';
import MainContent from '../MainContent';
import Footer from '../Footer';
import './index.scss';

const Category = ({ category }) => (
    <Fragment>
        <Header category={category}/>
        <Section className="lists-wrapper">
            <SideMenu category={category}/>
            <MainContent items={category.items}/>
        </Section>
        <Footer/>
    </Fragment>
);

Header.propTypes = {
    category: PropTypes.object
};

export default Category;
